import { useCallback } from 'react';
import { useLatest } from 'react-use';

export function useEvent<T extends any[] = any[], U extends any = any>(
  cb: (...args: T) => U
) {
  const lastFn = useLatest(cb);

  return useCallback(
    (...args: Parameters<typeof cb>) => {
      return lastFn.current(...args);
    },
    [lastFn]
  );
}
